<template>
  <div class="width98 margin-auto backwhite pad-bot40">
    <!-- 检索 -->
    <div class="width98 margin-auto">
      <div class="f16 dimensional">产品修改</div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="pad-top10 flex-aroundwrap"
      >
        <el-form-item label="产品名称" class="width32" prop="title">
          <el-input
            placeholder="请输入产品名称"
            v-model="form.title"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="立项时间" class="width32" prop="start_at">
          <el-date-picker
            class="inputDeep"
            v-model="form.start_at"
            type="date"
            placeholder="请选择立项时间"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="产品类别" class="width32" prop="cate_idbig">
          <div class="width100 flex-betweennowrap">
            <el-select
              class="width50"
              v-model="form.cate_idbig"
              placeholder="请选择产品类别"
              @change="optionbchange"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionb"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="form.cate_id"
              placeholder="请选择产品类别"
              class="width50"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionm"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="上游产业" class="width32" prop="upsteam">
          <el-input
            placeholder="请输入项目上游产业"
            v-model="form.upsteam"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="下游产业" class="width32" prop="downsteam">
          <el-input
            placeholder="请输入项目下游产业"
            v-model="form.downsteam"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="名企配套" class="width32" prop="well_known_used">
          <el-select
            v-model="form.well_known_used"
            placeholder="产品是否名企配套"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in form.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="技术关键词" class="width32" prop="tech_keyword">
          <el-input
            placeholder="请输入项目技术关键词"
            v-model="form.tech_keyword"
            class="width100"
          ></el-input>
        </el-form-item>

        <el-form-item label="技术垄断者" class="width32">
          <el-input
            placeholder="请输入技术垄断者"
            v-model="form.tech_controller"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联竞争对手" class="width32">
          <el-input
            placeholder="请输入关联竞争对手"
            v-model="form.opponent"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联专利" class="width32">
          <el-input
            placeholder="请输入关联专利"
            v-model="form.patent"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item class="width32"> </el-form-item>
        <el-form-item class="width32"> </el-form-item>
        <el-form-item label="产品封面" class="width98">
          <el-upload
            class="avatar-uploader"
            :action="Apisrcone"
            name="images"
            :show-file-list="false"
            :on-success="handleAvatarSuccesshead"
            :on-error="handleerrorhead"
            :data="userhead"
            :headers="head"
            style="margin-top: 40px"
          >
            <img
              v-if="form.pictureurl"
              :src="picturehead + form.pictureurl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="" class="width100">
          <p
            class="
              width98
              margin-auto
              textalign-left
              dimensional
              f14
              flex-betweenwrap
            "
          >
            <span>附件上传</span>
            <span class="f12" style="color: #969eac"
              >一次最多上传9个文件,单个文件不超过10M</span
            >
          </p>
          <div class="width98 margin-auto flex-leftwrap">
            <div
              v-for="(item, index) in filebox"
              :key="index"
              class="avatar lineheight25"
              style="margin-right: 20px; margin-top: 40px"
            >
              <div
                class="filebox"
                @mouseover="mouseOvers(index)"
                @mouseleave="mouseLeaves(index)"
              >
                <div
                  v-if="mousechanges == index ? true : false"
                  class="picturecont cursorpointer"
                >
                  <div class="picspan">
                    <span @click="picpreview(index)">
                      <img src="@/assets/barsvg/icon／14yl.png" alt="" /> </span
                    ><span @click="removepic(index)" class="margin-left20">
                      <img src="@/assets/barsvg/icon／14sc.png" alt="" />
                    </span>
                    <span @click="coverpic(index)" class="margin-left20">
                      <img src="@/assets/barsvg/icon／14fmth.png" alt="" />
                    </span>
                  </div>
                </div>
                <el-image
                  :src="picturehead + item.url"
                  class="pictureimg"
                ></el-image>
                <div class="bluecolor f12">
                  <p
                    style="
                      width: 100px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.original_name }}
                  </p>
                </div>
              </div>
            </div>
            <el-upload
              v-if="filebox.length != 0"
              class="avatar-uploader"
              :action="Apisrc"
              name="file"
              :show-file-list="mentSuccess"
              :on-success="gattachmentSuccess"
              :on-error="gattachmenterror"
              :before-upload="beforeupload"
              :data="gattachmentuser"
              :headers="head"
              multiple
              style="margin-right: 20px; margin-top: 40px"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div
            class="width98 margin-auto margin-top10"
            v-if="filebox.length == 0"
          >
            <el-upload
              class="upload-demo pad-top10 uploaddragger"
              drag
              :action="Apisrc"
              name="file"
              :show-file-list="mentSuccess"
              :on-success="gattachmentSuccess"
              :on-error="gattachmenterror"
              :before-upload="beforeupload"
              :data="gattachmentuser"
              :headers="head"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="" class="width98">
          <p class="textalign-left dimensional f14 margin-bot10">
            <span>产品详情</span>
          </p>
          <wangEditor
            v-model="form.remark"
            :isClear="isClear"
            class="textalign-left"
          ></wangEditor>
        </el-form-item>
      </el-form>
      <div class="textalign-right margin-right20 margin-top20">
        <el-button @click="dialogVisiblefalse()">取 消</el-button>
        <el-button type="primary" @click="toproductmanagement()">
          保存
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wangEditor from "@/components/wangEditor";
import {
  entproductdetail,
  entproductcate,
  entproductupdate,
  entproductsetpicture,
  entproductdeletefile,
} from "@/api/Center/Center.api";

import BUS from "@/BUS/BUS";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      imageUrl: "",
      form: {
        title: "",
        start_at: "",
        upsteam: "",
        cate_id: "",
        cate_idbig: "",
        downsteam: "",
        options: [
          {
            value: "0",
            label: "否",
          },
          {
            value: "1",
            label: "是",
          },
        ],
        well_known_used: "",
        tech_keyword: "",
        patent: "",
        opponent: "",
        tech_controller: "",
        remark: "",
        picture: "",
        pictureurl: "",
      },
      userhead: {
        images: "",
      },
      gattachmentuser: {
        filename: "",
        product_id: "",
      },

      picturehead: "",
      mentSuccess: true,
      mousechanges: "",
      Apisrc: "",
      Apisrcs: "",
      Apisrcone: "",
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      rules: {
        title: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
        upsteam: [
          { required: true, message: "请输入项目上游产业", trigger: "blur" },
        ],
        downsteam: [
          { required: true, message: "请输入项目下游产业", trigger: "blur" },
        ],
        start_at: [
          {
            type: "date",
            required: true,
            message: "请选择立项时间",
            trigger: "blur",
          },
        ],

        well_known_used: [
          {
            required: true,
            message: "产品是否名企配套：",
            trigger: "blur",
          },
        ],

        cate_idbig: [
          { required: true, message: "请选择产品类别", trigger: "blur" },
        ],
        tech_keyword: [
          { required: true, message: "请输入技术关键词", trigger: "blur" },
        ],
      },
      optionb: [],
      optionm: [],
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
      wangEditorDetail: "",
      filebox: [],
      files: [],
    };
  },
  components: { wangEditor },
  methods: {
    // 上传附件
    handleAvatarSuccesshead(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.form.picture = res.name;
        this.form.pictureurl = response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    handleerrorhead(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    beforeupload(file) {
      this.gattachmentuser.filename = file.name;
    },
    // 上传附件
    gattachmentSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.mentSuccess = false;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        entproductdetail({
          id: this.gattachmentuser.product_id,
        }).then((res) => {
          if (res.data.code == 200) {
            this.filebox = res.data.data.files;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    gattachmenterror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 移入
    mouseOvers(index) {
      this.mousechanges = index;
    },
    // 移出
    mouseLeaves(index) {
      this.mousechanges = -1;
    },
    // 预览
    picpreview(index) {
      var url = window.g.Apisrc + this.filebox[index].url;
      window.open(
        window.g.previewurl + "?url=" + encodeURIComponent(Base64.encode(url))
      );
    },
    // 删除
    removepic(index) {
      entproductdeletefile({ id: this.filebox[index].id }).then((res) => {
        entproductdetail({
          id: this.gattachmentuser.product_id,
        }).then((res) => {
          if (res.data.code == 200) {
            this.filebox = res.data.data.files;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      });
    },
    // 设为封面
    coverpic(index) {
      entproductsetpicture({ id: this.filebox[index].id }).then((res) => {
        this.$message({
          showClose: true,
          message: "已设置为封面",
          type: "success",
        });
        if (res.data.code == 200) {
          this.form.pictureurl = this.filebox[index].url;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 产品数据修改
    toproductmanagement() {
      this.filebox.forEach((i) => {
        this.files.push(i.id);
      });
      if (this.form.well_known_used == "是") {
        this.form.well_known_used = 1;
      } else if (this.form.well_known_used == "否") {
        this.form.well_known_used = 0;
      }
      if (typeof this.form.cate_idbig == "string") {
        this.form.cate_idbig = this.page.bigcate.id;
        this.form.cate_id = this.page.cate_id;
      }
      entproductupdate({
        id: this.gattachmentuser.product_id,
        title: this.form.title,
        start_at: this.form.start_at,
        upsteam: this.form.upsteam,
        cate_id: this.form.cate_id,
        big_cate_id: this.form.cate_idbig,
        downsteam: this.form.downsteam,
        well_known_used: this.form.well_known_used,
        tech_keyword: this.form.tech_keyword,
        patent: this.form.patent,
        opponent: this.form.opponent,
        tech_controller: this.form.tech_controller,
        picture: this.form.pictureurl,
        remark: this.form.remark,
        files: this.files,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });

          BUS.$emit("promanage", 1);
          BUS.$emit("promanageid", res.data.data.id);
          this.$router.push({
            path: "/development-Administration/product-management",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialogVisiblefalse() {
      this.$router.push({
        path: "/development-Administration/product-management",
      });
      BUS.$emit("promanage", 1);
    },
    optionbchange(value) {
      this.form.cate_id = "";
      entproductcate({
        parent_id: value,
      }).then((res) => {
        if (res.data.code == 200) {
          this.optionm = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/ent_product/uploader";
    this.Apisrcs = window.g.ApiUrl + "/ent_product/uploader";
    this.picturehead = window.g.Apisrc;
    this.Apisrcone = window.g.ApiUrl + "/oss_form";
    this.gattachmentuser.product_id =
      window.sessionStorage.getItem("promanageid");
    entproductdetail({
      id: this.gattachmentuser.product_id,
    }).then((res) => {
      this.form.title = res.data.data.title;
      this.form.start_at = res.data.data.start_at;
      this.form.upsteam = res.data.data.upsteam;
      this.form.cate_id = res.data.data.cate.name;
      this.form.cate_idbig = res.data.data.bigcate.name;
      this.form.downsteam = res.data.data.downsteam;
      this.form.well_known_used = res.data.data.well_known_used;
      this.form.tech_keyword = res.data.data.tech_keyword;
      this.form.patent = res.data.data.patent;
      this.form.opponent = res.data.data.opponent;
      this.form.tech_controller = res.data.data.tech_controller;
      this.form.remark = res.data.data.remark;
      this.form.pictureurl = res.data.data.picture;
      this.form.picture = res.data.data.picture;
      this.filebox = res.data.data.files;
      this.page = res.data.data;
      if (res.data.data.well_known_used == 0) {
        this.form.well_known_used = "否";
      } else {
        this.form.well_known_used = "是";
      }
      if (res.data.code == 200) {
        this.filebox = res.data.data.files;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    entproductcate().then((res) => {
      if (res.data.code == 200) {
        this.optionb = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("promanageid", (data) => {
      this.gattachmentuser.product_id = data;
      entproductdetail({
        id: data,
      }).then((res) => {
        this.form.title = res.data.data.title;
        this.form.start_at = res.data.data.start_at;
        this.form.upsteam = res.data.data.upsteam;
        this.form.cate_id = res.data.data.cate.name;
        this.form.cate_idbig = res.data.data.bigcate.name;
        this.form.downsteam = res.data.data.downsteam;
        this.form.well_known_used = res.data.data.well_known_used;
        this.form.tech_keyword = res.data.data.tech_keyword;
        this.form.patent = res.data.data.patent;
        this.form.opponent = res.data.data.opponent;
        this.form.tech_controller = res.data.data.tech_controller;
        this.form.remark = res.data.data.remark;
        this.form.pictureurl = res.data.data.picture;
        this.form.picture = res.data.data.picture;
        this.filebox = res.data.data.files;
        this.page = res.data.data;
        if (res.data.data.well_known_used == 0) {
          this.form.well_known_used = "否";
        } else {
          this.form.well_known_used = "是";
        }

        if (res.data.code == 200) {
          this.filebox = res.data.data.files;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
<style scoped>
.dimensional {
  padding: 20px 0 0 10px;
}
.picturecont {
  width: 100%;
  height: 100%;
  background-color: rgb(85 0 0 / 46%);
  position: absolute;
  text-align: center;
  color: white;
  z-index: 2;
}
.pictureimg {
  width: 100%;
  height: 110px;
}
.filebox {
  width: 100%;
  height: 110px;
  margin: 0 0 50px 0;
  border: 1px solid #efefef;
  position: relative;
}
.picspan {
  position: relative;
  top: 40%;
  z-index: 3;
}
.uploaddragger >>> .el-upload {
  width: 100%;
}
.uploaddragger >>> .el-upload-dragger {
  width: 100%;
  margin: auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #6e6d6d;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploaddragger >>> .el-upload-dragger:hover {
  border-color: #52c5cb;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  /* text-align: center; */
  border: 1px dashed #e5e5e5;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
}
.el-form-item {
  margin: 10px 0;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>